import { Link, useLocation } from "@tanstack/react-router";
import { MessagePage } from "../components/MessagePage";

export default function NotFound() {
	const location = useLocation();

	return (
		<MessagePage
			title="Her har sola gått ned for godt"
			actions={
				<Link to="/" className="btn-primary">
					Til forsiden
				</Link>
			}
		>
			<p>
				Vi fant ikke siden <code className="rounded bg-sunken px-1.5 py-0.5 text-sm text-ink">{location.pathname}</code>
				. Sjekk adressen, eller start på forsiden.
			</p>
		</MessagePage>
	);
}
